export default __webpack_public_path__ + "static/media/add-user.553545bd.png";